// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'portal.solicitarCargasPage.title': 'Solicitar cargas',
    'portal.solicitarCargasPage.eyebrow': 'Portal do cliente',
    'portal.solicitarCargasPage.subtitle': 'Escolha o contrato e monte as cargas. A fazenda vem do contrato e o destino é geral.',
    'portal.solicitarCargasPage.stepContract': 'Contrato',
    'portal.solicitarCargasPage.stepLoads': 'Cargas',
    'portal.solicitarCargasPage.selectPlaceholder': 'Selecione',
    'portal.solicitarCargasPage.searchDest': 'Buscar destino…',
    'portal.solicitarCargasPage.selectContractLabel': 'Selecione o contrato',
    'portal.solicitarCargasPage.searchContract': 'Buscar contrato…',
    'portal.solicitarCargasPage.producer': 'Produtor',
    'portal.solicitarCargasPage.city': 'Município',
    'portal.solicitarCargasPage.farm': 'Fazenda',
    'portal.solicitarCargasPage.contractDest': 'Destino do contrato',
    'portal.solicitarCargasPage.loadsHint': 'uma linha por carga',
    'portal.solicitarCargasPage.defaultsHint': 'Padrões. O horário é gerado por “Início + Intervalo”. Edite qualquer célula para ajustar uma carga.',
    'portal.solicitarCargasPage.date': 'Data',
    'portal.solicitarCargasPage.start': 'Início',
    'portal.solicitarCargasPage.intervalMin': 'Intervalo em min',
    'portal.solicitarCargasPage.loadCount': 'Qtd. cargas',
    'portal.solicitarCargasPage.destGeneral': 'Destino geral',
    'portal.solicitarCargasPage.addDestTooltip': 'Cadastrar novo destino',
    'portal.solicitarCargasPage.applyAll': 'Aplicar a todas',
    'portal.solicitarCargasPage.day': 'Dia',
    'portal.solicitarCargasPage.time': 'Horário',
    'portal.solicitarCargasPage.removeLoadTooltip': 'Remover carga',
    'portal.solicitarCargasPage.removeLoadAria': 'Remover carga {{n}}',
    'portal.solicitarCargasPage.emptyLoads': 'Nenhuma carga. Ajuste a “Qtd. cargas” ou clique em “Adicionar carga”.',
    'portal.solicitarCargasPage.addLoad': 'Adicionar carga',
    'portal.solicitarCargasPage.sending': 'Enviando…',
    'portal.solicitarCargasPage.sendRequest': 'Enviar solicitação',
    'portal.solicitarCargasPage.newDestTitle': 'Novo destino',
    'portal.solicitarCargasPage.unloadingPlaceName': 'Nome do local de descarga',
    'portal.solicitarCargasPage.newDestPlaceholder': 'Ex.: Valorem Paracatu',
    'portal.solicitarCargasPage.toastDestCreated': 'Destino cadastrado.',
    'portal.solicitarCargasPage.toastRequestSent': 'Solicitação enviada ao backoffice!',
    'portal.solicitarCargasPage.errSelectContract': 'Selecione o contrato.',
    'portal.solicitarCargasPage.errSelectDest': 'Selecione o destino da solicitação.',
    'portal.solicitarCargasPage.errAddLoad': 'Adicione ao menos uma carga.',
    'portal.solicitarCargasPage.errLoadDateTime': 'Carga {{n}}: informe data e horário.',
  },
  en: {
    'portal.solicitarCargasPage.title': 'Request loads',
    'portal.solicitarCargasPage.eyebrow': 'Customer portal',
    'portal.solicitarCargasPage.subtitle': 'Choose the contract and build the loads. The farm comes from the contract and the destination is general.',
    'portal.solicitarCargasPage.stepContract': 'Contract',
    'portal.solicitarCargasPage.stepLoads': 'Loads',
    'portal.solicitarCargasPage.selectPlaceholder': 'Select',
    'portal.solicitarCargasPage.searchDest': 'Search destination…',
    'portal.solicitarCargasPage.selectContractLabel': 'Select the contract',
    'portal.solicitarCargasPage.searchContract': 'Search contract…',
    'portal.solicitarCargasPage.producer': 'Producer',
    'portal.solicitarCargasPage.city': 'Municipality',
    'portal.solicitarCargasPage.farm': 'Farm',
    'portal.solicitarCargasPage.contractDest': 'Contract destination',
    'portal.solicitarCargasPage.loadsHint': 'one row per load',
    'portal.solicitarCargasPage.defaultsHint': 'Defaults. The time is generated from “Start + Interval”. Edit any cell to adjust a load.',
    'portal.solicitarCargasPage.date': 'Date',
    'portal.solicitarCargasPage.start': 'Start',
    'portal.solicitarCargasPage.intervalMin': 'Interval in min',
    'portal.solicitarCargasPage.loadCount': 'Load count',
    'portal.solicitarCargasPage.destGeneral': 'General destination',
    'portal.solicitarCargasPage.addDestTooltip': 'Add new destination',
    'portal.solicitarCargasPage.applyAll': 'Apply to all',
    'portal.solicitarCargasPage.day': 'Day',
    'portal.solicitarCargasPage.time': 'Time',
    'portal.solicitarCargasPage.removeLoadTooltip': 'Remove load',
    'portal.solicitarCargasPage.removeLoadAria': 'Remove load {{n}}',
    'portal.solicitarCargasPage.emptyLoads': 'No loads. Adjust “Load count” or click “Add load”.',
    'portal.solicitarCargasPage.addLoad': 'Add load',
    'portal.solicitarCargasPage.sending': 'Sending…',
    'portal.solicitarCargasPage.sendRequest': 'Send request',
    'portal.solicitarCargasPage.newDestTitle': 'New destination',
    'portal.solicitarCargasPage.unloadingPlaceName': 'Unloading location name',
    'portal.solicitarCargasPage.newDestPlaceholder': 'e.g. Valorem Paracatu',
    'portal.solicitarCargasPage.toastDestCreated': 'Destination added.',
    'portal.solicitarCargasPage.toastRequestSent': 'Request sent to the backoffice!',
    'portal.solicitarCargasPage.errSelectContract': 'Select the contract.',
    'portal.solicitarCargasPage.errSelectDest': 'Select the request destination.',
    'portal.solicitarCargasPage.errAddLoad': 'Add at least one load.',
    'portal.solicitarCargasPage.errLoadDateTime': 'Load {{n}}: enter date and time.',
  },
  es: {
    'portal.solicitarCargasPage.title': 'Solicitar cargas',
    'portal.solicitarCargasPage.eyebrow': 'Portal del cliente',
    'portal.solicitarCargasPage.subtitle': 'Elige el contrato y arma las cargas. La finca viene del contrato y el destino es general.',
    'portal.solicitarCargasPage.stepContract': 'Contrato',
    'portal.solicitarCargasPage.stepLoads': 'Cargas',
    'portal.solicitarCargasPage.selectPlaceholder': 'Seleccione',
    'portal.solicitarCargasPage.searchDest': 'Buscar destino…',
    'portal.solicitarCargasPage.selectContractLabel': 'Selecciona el contrato',
    'portal.solicitarCargasPage.searchContract': 'Buscar contrato…',
    'portal.solicitarCargasPage.producer': 'Productor',
    'portal.solicitarCargasPage.city': 'Municipio',
    'portal.solicitarCargasPage.farm': 'Finca',
    'portal.solicitarCargasPage.contractDest': 'Destino del contrato',
    'portal.solicitarCargasPage.loadsHint': 'una fila por carga',
    'portal.solicitarCargasPage.defaultsHint': 'Valores predeterminados. El horario se genera con “Inicio + Intervalo”. Edita cualquier celda para ajustar una carga.',
    'portal.solicitarCargasPage.date': 'Fecha',
    'portal.solicitarCargasPage.start': 'Inicio',
    'portal.solicitarCargasPage.intervalMin': 'Intervalo en min',
    'portal.solicitarCargasPage.loadCount': 'Cant. cargas',
    'portal.solicitarCargasPage.destGeneral': 'Destino general',
    'portal.solicitarCargasPage.addDestTooltip': 'Registrar nuevo destino',
    'portal.solicitarCargasPage.applyAll': 'Aplicar a todas',
    'portal.solicitarCargasPage.day': 'Día',
    'portal.solicitarCargasPage.time': 'Horario',
    'portal.solicitarCargasPage.removeLoadTooltip': 'Eliminar carga',
    'portal.solicitarCargasPage.removeLoadAria': 'Eliminar carga {{n}}',
    'portal.solicitarCargasPage.emptyLoads': 'Sin cargas. Ajusta “Cant. cargas” o haz clic en “Agregar carga”.',
    'portal.solicitarCargasPage.addLoad': 'Agregar carga',
    'portal.solicitarCargasPage.sending': 'Enviando…',
    'portal.solicitarCargasPage.sendRequest': 'Enviar solicitud',
    'portal.solicitarCargasPage.newDestTitle': 'Nuevo destino',
    'portal.solicitarCargasPage.unloadingPlaceName': 'Nombre del lugar de descarga',
    'portal.solicitarCargasPage.newDestPlaceholder': 'Ej.: Valorem Paracatu',
    'portal.solicitarCargasPage.toastDestCreated': 'Destino registrado.',
    'portal.solicitarCargasPage.toastRequestSent': '¡Solicitud enviada al backoffice!',
    'portal.solicitarCargasPage.errSelectContract': 'Selecciona el contrato.',
    'portal.solicitarCargasPage.errSelectDest': 'Selecciona el destino de la solicitud.',
    'portal.solicitarCargasPage.errAddLoad': 'Agrega al menos una carga.',
    'portal.solicitarCargasPage.errLoadDateTime': 'Carga {{n}}: ingresa fecha y horario.',
  },
}
